{
  "app": {
    "title": "SMS Stock Management",
    "subtitle": "Supplier × Logistics × CoEldery 85",
    "language": "Language"
  },
  "nav": {
    "dashboard": "Dashboard",
    "master": "Master data",
    "settings": "Settings",
    "intake": "Intake",
    "build": "Build",
    "pending": "To receive",
    "myShipments": "My shipments",
    "inventory": "Stock",
    "movements": "Ledger",
    "outbound": "Outbound",
    "weeklyFee": "Storage fees",
    "reports": "Weekly report",
    "todo": "Open items"
  },
  "common": {
    "loading": "Loading…",
    "loadFailed": "Could not load, please retry",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved ✓",
    "add": "Add",
    "adding": "Adding…",
    "refresh": "Reload",
    "optional": "(optional)"
  },
  "setup": {
    "title": "First sign-in: set your email + a new password",
    "intro": "Hello {{name}}! This is your first sign-in — please set your email and a new password; you will sign in with your email from now on.",
    "email": "Email",
    "emailHint": "You will sign in with this email + password (unique across the system).",
    "currentPassword": "Current (preset) password",
    "currentHint": "The preset password you just used.",
    "newPassword": "New password",
    "confirm": "Repeat new password",
    "policy": "At least 8 characters; must differ from the preset password.",
    "mismatch": "The two new passwords do not match",
    "submit": "Save and start using",
    "titleChange": "Change email / password",
    "introChange": "{{name}}, you can change your sign-in email and password here (current password required).",
    "currentPasswordChange": "Current password",
    "newPasswordChange": "New password (repeat the current one if unchanged)",
    "submitChange": "Save",
    "currentEmail": "Current email: {{email}}"
  },
  "po": {
    "intro": "Order stock from suppliers: replenish by the safety-level suggestion; the supplier confirms the order (may reduce quantities and set an ETA).",
    "supplierIntro": "Purchase orders from CoEldery 85 appear here: confirm the order (quantities + ETA) or ship it.",
    "shortageTitle": "Below safety level (suggested replenishment)",
    "shortageHint": "Listed when stock on hand (= in − out) is below the safety level you set; set it in Master data → Items.",
    "shortageEmpty": "Nothing is below its safety level ✓",
    "suggest": "suggest {{n}} cartons",
    "newTitle": "New purchase order",
    "supplier": "Supplier",
    "pick": "Please pick",
    "requestedAt": "Requested arrival date",
    "requestedAtHint": "The supplier fills the actual ETA when confirming; this is your expectation.",
    "item": "Item",
    "cartons": "Cartons",
    "addLine": "Add a line",
    "removeLine": "Remove a line",
    "note": "Note",
    "submit": "Create order (draft)",
    "created": "Order {{no}} created ✓ (remember to press “Send”)",
    "listTitle": "Purchase orders",
    "empty": "No purchase orders yet.",
    "emptySupplier": "No purchase orders from CoEldery 85 yet.",
    "eta": "ETA",
    "onHand": "on hand",
    "safeLevel": "safety level",
    "ackHint": "⚠️ You may only reduce quantities (never add) — any change requires a reason.",
    "ackNote": "Reason for the change (required if quantities changed)",
    "ordered": "Ordered (cartons)",
    "acked": "Confirmed (cartons)",
    "close": "Collapse",
    "linkedIntake": "Shipment {{no}} was created automatically (status {{status}}) — logistics will receive it as usual.",
    "status": {
      "draft": "Draft",
      "sent": "Sent",
      "ack": "Confirmed",
      "shipped": "Shipped",
      "received": "Received",
      "closed": "Closed",
      "cancelled": "Cancelled"
    },
    "act": {
      "send": "Send",
      "ack": "Confirm order",
      "ship": "Ship",
      "receive": "Mark received",
      "close": "Close",
      "cancel": "Cancel"
    },
    "ask": {
      "cancel": "Cancel this purchase order?"
    },
    "done": {
      "send": "Sent ✓",
      "ack": "Order confirmed ✓",
      "ship": "Shipped (shipment created) ✓",
      "receive": "Marked received ✓",
      "close": "Closed ✓",
      "cancel": "Cancelled ✓"
    }
  },
  "tab": {
    "aria": "Bottom navigation",
    "menu": "Menu",
    "language": "Language",
    "newVersion": "A new version is available — please reload",
    "password": "Change password",
    "account": "Change email / password",
    "todo": "Open items",
    "reports": "Weekly report / export",
    "master": "Master data (suppliers / items)",
    "ledger": "Ledger",
    "settings": "Settings (rates / destinations…)",
    "me": "My company",
    "orders": "Orders",
    "shipment": "Shipments",
    "stock": "Stock",
    "incoming": "Incoming",
    "pickup": "Pickup",
    "fees": "Storage fees",
    "overview": "Overview",
    "purchase": "Purchase",
    "outbound": "Outbound",
    "disposition": "Where stock went"
  },
  "me": {
    "title": "My company",
    "intro": "Your company's basic details (changes take effect immediately).",
    "code": "Supplier code",
    "codeHint": "⚠️ The code is your identity (orders and reconciliation use it) — ask a CoEldery 85 staff member to change it.",
    "name": "Company name",
    "contactName": "Contact person",
    "contactPhone": "Contact phone",
    "waNumber": "WhatsApp number",
    "waHint": "International format (e.g. 85291234567) — outbound notices go to the logistics group (P1-8).",
    "saved": "Saved ✓",
    "attrsTitle": "Custom fields",
    "attrsHint": "Future fields will show up here (no database change needed; set by the administrator).",
    "attrsEmpty": "No custom fields yet."
  },
  "orders": {
    "title": "Orders",
    "intro": "Purchase orders from CoEldery 85 will appear here.",
    "buildingTitle": "⏳ Under construction (P1.5-B)",
    "buildingBody": "Purchase orders are being built: you will see the order number, quantity and ETA here, and be able to confirm / change quantity / set ETA. For now please create your shipment under “Shipments”.",
    "gotoShipments": "Go to Shipments (create a shipment) →"
  },
  "purchase": {
    "title": "Purchase",
    "intro": "Order new stock from suppliers (quantities suggested by the safety level).",
    "buildingTitle": "⏳ Under construction (P1.5-B)",
    "buildingBody": "Purchase orders are being built: you will pick items, see the suggested quantity from the safety level, and the supplier confirms before shipping.",
    "gotoOutbound": "Go to Outbound (order from the warehouse) →"
  },
  "myItems": {
    "title": "My items",
    "hint": "Your item list (cbm is computed from carton dimensions). Once an item exists you can create a shipment from “Shipments”.",
    "add": "＋ Add item",
    "hideAdd": "Hide the form",
    "empty": "No items yet — tap “＋ Add item” above to add the first one.",
    "unitsPerCarton": "Units per carton",
    "cartonSize": "Carton size (L×W×H)",
    "cbmPerCarton": "cbm per carton",
    "safeLevel": "Safety level (cartons)",
    "inactive": "Inactive"
  },
  "pwd": {
    "title": "Change password",
    "intro": "After changing, your other devices are signed out immediately (this device stays).",
    "current": "Current password",
    "next": "New password",
    "confirm": "Repeat new password",
    "policy": "At least 8 characters; common weak passwords are rejected.",
    "mismatch": "The two new passwords do not match",
    "submit": "Change password",
    "done": "Password changed ✓",
    "back": "Back →"
  },
  "stock": {
    "formulaTitle": "How stock is counted: in − out = now",
    "formulaHint": "Stock in (into the warehouse) minus stock out (leaving) = what is in the warehouse now. All roles read the same ledger, so the figures always agree.",
    "scoped": "You only see your own goods (partner data isolation).",
    "in": "In",
    "out": "Out",
    "current": "In warehouse now",
    "ok": "Ledger consistent ✓",
    "mismatch": "⚠️ Formula and balance disagree (tell a staff member)",
    "empty": "No items yet.",
    "sku": "Item",
    "inCartons": "In (cartons)",
    "inCbm": "In (cbm)",
    "outCartons": "Out (cartons)",
    "outCbm": "Out (cbm)",
    "currentCartons": "Now (cartons)",
    "currentCbm": "Now (cbm)",
    "balanceCbm": "Balance check (cbm)"
  },
  "home": {
    "healthTitle": "System status",
    "checking": "Checking…",
    "dbUp": "Database connection OK",
    "dbUnbound": "Database not bound (for local dev run npm run dev:cf)",
    "apiDown": "API not responding"
  },
  "dash": {
    "title": "Dashboard",
    "intro": "What needs attention today (shown by your role; anything you cannot see is not shown)",
    "scoped": "You only see your own goods and orders (partner data isolation)",
    "pendingIntake": "To receive (batches)",
    "pendingOutbound": "To ship (orders)",
    "weekCbm": "This week cbm (billing base)",
    "weekCbmHint": "Opening balance rule: stock at {{week}}",
    "unconfirmedFees": "Fees to confirm (weeks)",
    "unsettledEvents": "⚠️ Events not settled",
    "unsettledEventsHint": "Direct-sale delivered but not reconciled",
    "missingChop": "⚠️ Missing delivery evidence",
    "missingChopHint": "Delivered but no chop/signature photo yet",
    "onSiteCbm": "On-site cbm",
    "pendingTitle": "Open items",
    "seeAllPending": "See all open items →"
  },
  "pending": {
    "title": "Open items",
    "intro": "Things someone must follow up: unsettled events / missing evidence / on-site stock (goal: no outbound order goes missing)",
    "summary": "{{events}} unsettled · {{chop}} missing evidence · {{cbm}} cbm on site",
    "unsettledTitle": "Unsettled events",
    "unsettledHint": "Direct-sale (direct_sale) delivered but not reconciled → ledger incomplete",
    "unsettledEmpty": "No unsettled events ✓",
    "missingChopTitle": "Missing delivery evidence",
    "missingChopHint": "Delivery (delivery) delivered but no chop/signature photo (can upload later)",
    "missingChopEmpty": "Every delivery note has evidence ✓",
    "missingChopBadge": "⚠️ missing chop photo",
    "onSiteTitle": "On-site stock",
    "onSiteHint": "Goods still at a roadshow venue",
    "onSiteEmpty": "Nothing left on site ✓",
    "cartons": "cartons",
    "units": "units",
    "cbm": "cbm",
    "skus": "SKUs",
    "deliveredAt": "Delivered",
    "openOrder": "Handle",
    "reload": "Reload"
  },
  "report": {
    "title": "Weekly report / export",
    "intro": "Storage fee detail + in/out summary (figures come straight from the fee module and the ledger — never a second calculation)",
    "week": "Week (Monday)",
    "prevWeek": "Previous week",
    "nextWeek": "Next week",
    "thisWeek": "This week",
    "exportXlsx": "Export Excel (.xlsx)",
    "exportCsv": "Export CSV",
    "exported": "Exported {{name}}",
    "sheetFee": "Storage fees",
    "sheetLedger": "In/out summary",
    "sheetBatches": "Intake batches",
    "sheetPending": "Open items",
    "feeTitle": "Storage fee detail",
    "feeHint": "Opening cbm × storage rate + intake handling fees of the week (opening rule; movements during the week do not affect it)",
    "ledgerTitle": "In/out summary",
    "ledgerHint": "Ledger (stock_movements) grouped by movement type — the single source of truth",
    "batchTitle": "Intake batches",
    "batchHint": "Batches received this week (handling fee belongs to this week)",
    "type": "Type",
    "count": "Count",
    "cartons": "Cartons",
    "units": "Units",
    "cbm": "cbm",
    "status": "Status",
    "batchNo": "Batch no",
    "supplier": "Supplier",
    "receivedDate": "Received",
    "receivedCbm": "Received cbm",
    "handlingFee": "Handling fee",
    "item": "Item",
    "value": "Value",
    "notGenerated": "Not generated",
    "generatedAt": "Generated at",
    "matchesOk": "(matches live recalculation ✓)",
    "matchesBad": "(⚠️ differs from live recalculation)",
    "issues": "⚠️ ",
    "noLedger": "No ledger movements this week",
    "noBatch": "No intake batch this week",
    "pendingLine": "Open items: {{events}} unsettled · {{chop}} missing evidence",
    "gotoFees": "Generate / confirm storage fees →"
  },
  "login": {
    "title": "Sign in",
    "username": "Username",
    "identifier": "Email or username",
    "identifierHint": "Use your username for the first sign-in (e.g. S0001); after setting an email, sign in with your email.",
    "password": "Password",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "failed": "Sign-in failed, please retry",
    "logout": "Sign out",
    "welcome": "Hello, {{name}}"
  },
  "role": {
    "supplier": "Supplier",
    "logistics": "Logistics partner",
    "staff": "CoEldery 85 staff",
    "admin": "Administrator"
  },
  "master": {
    "title": "Master data: suppliers / items",
    "suppliersTitle": "Suppliers (goods owners)",
    "itemsTitle": "Items (SKU)",
    "code": "Supplier code",
    "name": "Name",
    "contactName": "Contact person",
    "contactPhone": "Contact phone",
    "waNumber": "WhatsApp number",
    "addSupplier": "Add supplier",
    "supplierCreated": "Supplier added ✓",
    "supplier": "Supplier",
    "filterSupplier": "Filter by supplier",
    "allSuppliers": "All suppliers",
    "itemName": "Item name",
    "barcode": "Barcode",
    "unitsPerCarton": "Units per carton",
    "cartonDims": "Carton size",
    "cartonL": "Length (cm)",
    "cartonW": "Width (cm)",
    "cartonH": "Height (cm)",
    "cbmOverride": "cbm override",
    "weightKg": "Weight per carton (kg)",
    "cbm": "cbm per carton",
    "cbmPerUnit": "cbm per unit",
    "addItem": "Add item",
    "pickSupplierFirst": "⚠️ Pick a supplier first (that is why “Add item” does nothing)",
    "itemCreated": "Item added ✓",
    "photo": "Photo",
    "uploadPhoto": "Upload photo",
    "photoUploading": "Uploading…",
    "photoUploaded": "Photo uploaded ✓",
    "noPhoto": "No photo",
    "emptySuppliersTitle": "No suppliers yet",
    "emptySuppliersBody": "Add one goods owner first, then you can add items.",
    "emptyItemsTitle": "No items yet",
    "emptyItemsBody": "Pick a supplier, then add the first item.",
    "hintCbm": "cbm per carton is computed from the size (L×W×H÷1,000,000); storage fees use this number.",
    "hintBarcode": "One barcode = one item (unique system-wide).",
    "hintOverride": "Only fill this when the measured size is unreliable; it wins over the formula."
  },
  "settings": {
    "title": "Settings (back office)",
    "note": "Rates, settlement day and WhatsApp settings live here — never hard-coded.",
    "save": "Save settings",
    "saved": "Saved ✓",
    "saveFailed": "Save failed",
    "feeHandlingPerCbm": "Handling fee (per cbm, HK$)",
    "feeStoragePerCbmWeek": "Storage fee (per cbm per week, HK$)",
    "settlementWeekday": "Weekly settlement day",
    "feeFirstStorageFrom": "First storage date (first batch arrival)",
    "hintFirstStorageFrom": "Blank = no special case. When set, the settlement week containing this date counts movements ON that date as opening CBM (e.g. stock arriving 2026-09-23 is charged for 9/23–9/29).",
    "waTemplateOutbound": "Outbound template name",
    "waTemplatePicked": "Picked-notification template name",
    "waTemplateLang": "Template language",
    "waMaxItemsInMessage": "Max items listed in one message",
    "waRecipients": "WhatsApp recipients (phones)",
    "waRecipientsStaff": "Order-placer WhatsApp recipients (phones)",
    "outboundOrderNoPrefix": "Outbound order no. prefix",
    "outboundDeliveryCodePrefix": "Delivery code prefix",
    "intakeBatchNoPrefix": "Intake batch prefix",
    "weekday1": "Monday",
    "weekday2": "Tuesday",
    "weekday3": "Wednesday",
    "weekday4": "Thursday",
    "weekday5": "Friday",
    "weekday6": "Saturday",
    "weekday7": "Sunday",
    "hintRecipients": "Digits with country code only (e.g. 85291234567); separate multiple with commas.",
    "hintRecipientsStaff": "Notifies the staff who placed the order once picking is done; needs an approved picked-notification template. Digits with country code only.",
    "hintTemplate": "Must match the Meta-approved template name exactly.",
    "hintTemplatePicked": "Template used for the picked notification (e.g. sms_outbound_picked); nothing is sent before Meta approves it.",
    "appBaseUrl": "Public base URL (used in WhatsApp links)",
    "hintBaseUrl": "e.g. https://sms.85ai.app — the \"open system\" button in WhatsApp uses this; ⚠️ do not use *.pages.dev (hash changes every deploy)"
  },
  "order": {
    "linkTitle": "Outbound instruction {{orderNo}}",
    "linkBody": "You arrived from the WhatsApp notice. This page looks up that outbound order for you; press “Go to pick list” when you are ready to pick.",
    "lookingUp": "Looking up that outbound order…",
    "notFound": "Order {{orderNo}} was not found (it may not exist, or the number is wrong).",
    "noAccess": "Your account has no outbound access (outbound is limited to logistics, staff and admins).",
    "openOrder": "View outbound order",
    "startPick": "Go to pick list",
    "goHome": "Go to home"
  },
  "intake": {
    "titleSupplier": "My shipments",
    "titleLogistics": "Intake / to receive",
    "newBatch": "New shipment",
    "batchNo": "Batch no.",
    "supplier": "Supplier",
    "declaredShipDate": "Ship date",
    "receivedDate": "Received (start date)",
    "status": "Status",
    "declaredCbm": "Declared cbm",
    "receivedCbm": "Received cbm",
    "handlingFee": "Handling fee",
    "note": "Note",
    "items": "Items",
    "item": "Item",
    "pickItem": "Pick item",
    "declaredCartons": "Declared cartons",
    "receivedCartons": "Received cartons",
    "damagedCartons": "Damaged cartons",
    "productionDate": "Production date",
    "expiryDate": "Expiry date",
    "addLine": "Add an item",
    "removeLine": "Remove",
    "create": "Create shipment",
    "created": "Shipment created ✓",
    "needLine": "At least one line is required (each line needs an item + cartons)",
    "verify": "Confirm receipt (books stock now)",
    "verifying": "Booking…",
    "verified": "Received and booked ✓",
    "verifyHint": "If received ≠ declared you must give a reason; any damage requires a carton photo.",
    "diffReason": "Reason for difference",
    "damagePhoto": "Damage photo",
    "uploadDamage": "Upload photo",
    "uploading": "Uploading…",
    "uploaded": "Uploaded ✓",
    "damageNeedPhoto": "Damage requires a carton photo (policy)",
    "statusDeclared": "Declared (not received)",
    "statusReceived": "Received",
    "statusVerified": "Reconciled",
    "statusDiscrepancy": "Discrepancy",
    "statusCancelled": "Cancelled",
    "filterStatus": "Filter by status",
    "allStatus": "All statuses",
    "emptyTitle": "No shipments yet",
    "emptyBody": "Once a supplier creates the first shipment, logistics will see it here.",
    "emptyPendingTitle": "Nothing to receive",
    "emptyPendingBody": "Shipments appear here as soon as a supplier declares one.",
    "open": "Open",
    "back": "Back to list",
    "detailTitle": "Shipment detail",
    "readOnly": "Only logistics, staff or admin can reconcile a receipt.",
    "damagedNote": "Damaged goods go to the in-warehouse damage area: still billed, never shipped.",
    "addItemFirst": "Add an item first",
    "itemsTitle": "Items (line by line)",
    "lineNoItem": "Line {{n}}: no item selected — pick one in the “Item” dropdown (tap “Add item” first if the list is empty)",
    "lineNoCartons": "Line {{n}}: cartons missing (must be 1 or more)",
    "itemAddedLine": "“{{name}}” was added to the shipment — please enter the cartons",
    "addItemToggle": "+ New item"
  },
  "loc": {
    "warehouse": "Warehouse",
    "damaged": "Damaged",
    "office": "Office",
    "supplier": "Supplier (not shipped)",
    "writtenOff": "Written off"
  },
  "inv": {
    "title": "Stock balances",
    "intro": "How much stock sits in each location. cbm is the billing basis; damaged goods stay billable while still in the warehouse.",
    "rowsTitle": "Balances by location",
    "mirrorHidden": "{{n}} ledger-offset row(s) hidden (negative = the other side of the ledger, not actual stock)",
    "showMirror": "Show ledger-offset rows",
    "mirrorHint": "⭐ Why negative: each receipt writes a single movement \"supplier → warehouse\", and balances are net per location — so the source location (e.g. supplier, not yet shipped) always carries an equal negative. All locations summing to 0 is normal and does not affect storage rent (only the warehouse and damaged locations are billed).",
    "filterLocation": "Location",
    "allLocations": "All locations",
    "filterSupplier": "Supplier",
    "allSuppliers": "All suppliers",
    "includeEmpty": "Also show emptied (0 carton) locations",
    "summaryWarehouse": "In-warehouse cbm (billing basis)",
    "summaryWarehouseHint": "= warehouse + damaged (decisions/003)",
    "summaryDamaged": "of which damaged",
    "summaryCounts": "SKUs / batches",
    "summaryCountsHint": "distinct SKUs / SKU-batch pairs",
    "byLocationTitle": "Breakdown by location (negative = already left that location — normal)",
    "invariantBad": "⚠️ Ledger not self-consistent: cbm across all locations = {{net}} (expected ≈ 0) — check the ledger now",
    "scopedNotice": "You only see your own goods (supplier scope, enforced server-side).",
    "emptyTitle": "No stock yet",
    "emptyBody": "Balances appear here right after an intake is verified.",
    "batch": "Batch",
    "cartons": "Cartons",
    "units": "Units"
  },
  "mov": {
    "title": "Stock ledger",
    "intro": "The ledger is the single source of truth and is append-only (to correct, add an Adjust entry — never edit the old row).",
    "filterType": "Type",
    "allTypes": "All types",
    "from": "From",
    "to": "To",
    "typeIn": "In",
    "typeOut": "Out",
    "typeSale": "Sale",
    "typeTransfer": "Transfer",
    "typeAdjust": "Adjust",
    "actor": "By",
    "ref": "Source",
    "emptyTitle": "No movements yet",
    "emptyBody": "The first entry appears after an intake is verified.",
    "prev": "Previous",
    "next": "Next",
    "pageInfo": "Page {{page}} / {{last}} ({{total}} entries)"
  },
  "out": {
    "title": "Outbound orders",
    "newOrder": "New outbound order",
    "newHint": "Choose “Direct sale” for roadshow orders, “Delivery” for deliveries or samples. CBM is always calculated by the system.",
    "create": "Create outbound order",
    "back": "Back to list",
    "backToOrder": "Back to order",
    "emptyTitle": "No outbound orders",
    "emptyBody": "The first order appears here once staff create one.",
    "filterStatus": "Status",
    "filterKind": "Kind",
    "allStatus": "All statuses",
    "allKinds": "All kinds",
    "kind": "Outbound kind",
    "kindDirectSale": "Direct sale",
    "kindDelivery": "Delivery",
    "destination": "Destination",
    "deliveryMode": "Pickup mode",
    "modeSelfPickup": "Self pickup",
    "modeLogistics": "By logistics",
    "pickupAt": "Pickup time",
    "hintPickupAt": "The WhatsApp notice shows this time; for deliveries use the actual delivery slot.",
    "consignee": "Consignee",
    "address": "Address",
    "note": "Note",
    "lines": "Items",
    "item": "Item",
    "itemCount": "Items",
    "pickItem": "Select item",
    "batch": "Batch",
    "batchAuto": "Auto (FIFO)",
    "cartons": "Cartons",
    "cbm": "CBM",
    "warehouseAvailable": "{{n}} carton(s) in warehouse",
    "addLine": "Add item",
    "removeLine": "Remove",
    "hintCartons": "Outbound is always whole cartons. Leaving the batch on Auto = the system picks the earliest-expiry batch (it splits lines across batches when needed); the order is rejected when stock is short (receive stock first).",
    "noItems": "No items yet — add items in Master data first.",
    "needDestination": "Please choose a destination",
    "needPickupAt": "Please enter the pickup time",
    "needConsignee": "Please enter the consignee",
    "needLine": "At least one item is required",
    "required": "required",
    "detailTitle": "Outbound order",
    "deliveryCode": "Delivery code",
    "waSentAt": "Notice sent at",
    "pickedAt": "Picked on",
    "toLoc": "Picked to",
    "outboundCbm": "Outbound CBM",
    "summary": "Pick summary",
    "declaredCartons": "Declared cartons",
    "picked": "Picked cartons",
    "pickedCartons": "Actually picked (cartons)",
    "pendingLines": "Not picked yet",
    "shortfall": "Shortfall",
    "pickDiscrepancy": "Pick discrepancy",
    "next": "Next step",
    "statusDraft": "Draft (not sent)",
    "statusSent": "Notified (awaiting pick)",
    "statusAcknowledged": "Picked (awaiting handover)",
    "statusDelivered": "Delivered",
    "statusReconciled": "Reconciled (awaiting close)",
    "statusClosed": "Completed",
    "statusCancelled": "Cancelled",
    "sendTitle": "WhatsApp outbound notice",
    "sendHint": "The consignee receives the pickup time and an “Open system” button. Sending moves the order to “Notified”; only then can it be picked.",
    "send": "Send notice",
    "sending": "Sending…",
    "preview": "Preview (no send)",
    "previewResult": "Preview result (nothing sent)",
    "template": "Template",
    "lang": "Language",
    "deepLink": "Link",
    "recipients": "Recipients (masked)",
    "sendOk": "Notice sent ✓",
    "sendFailed": "Send failed — the order stays a draft; fix and retry",
    "needStaffToSend": "Only staff or an admin can send the notice.",
    "goPick": "Go to pick list",
    "picklistTitle": "Pick list",
    "pickOnlyWhenSent": "Picking is allowed only after the notice is sent (otherwise nobody knows about the goods).",
    "pickDone": "✓ Picked — tap the button below when the client collects the goods (or they reach the destination); the date recorded is today.",
    "pickClosed": "This order has already been handed over (CoEldery 85 staff handle the next step).",
    "awaitingHandover": "⏳ Awaiting hand-over",
    "goHandOver": "Hand over",
    "confirmPick": "Confirm pick (posts the ledger now)",
    "pickInvalid": "Picked cartons must be a whole number of 0 or more",
    "pickTooMany": "You cannot pick more than declared ({{n}} cartons); create a new order for extra stock",
    "pickNeedReason": "A reason is required when picking less",
    "pickNote": "Reason / note",
    "pickNoteRequired": "Reason (required when picking less)",
    "cancel": "Cancel order",
    "cancelConfirm": "Cancel outbound order {{orderNo}}? It can no longer be picked.",
    "cancelledHint": "This order is cancelled.",
    "needsReconciliation": "Direct-sale orders still need post-show reconciliation (sold / left over / damaged + where leftovers go) before they can close.",
    "deliverTitle": "One-tap handover",
    "deliverHintDelivery": "Delivery / sample: one tap completes the order (date, stock and notifications are handled by the system).",
    "deliverHintSale": "Direct sale: one tap means handed over; CoEldery 85 staff then does the post-show reconciliation.",
    "deliver": "Confirm handover",
    "collectNow": "Collected",
    "deliverNow": "Delivered",
    "deliverSale": "Handed over (venue)",
    "deliverOneTapAsk": "Confirm “{{what}}”? (handover date = today; this cannot be undone)",
    "deliverNoteOptional": "+ Add note (optional)",
    "delivered": "Delivered ✓",
    "deliveredAt": "Handover date",
    "deliverNote": "Handover note",
    "needStaffToReconcile": "CoEldery 85 staff will do the post-show reconciliation / close (the warehouse is done).",
    "printDeliveryNote": "Print delivery note (PDF)",
    "printDeliveryNoteHint": "The note is system generated (with the delivery code). It opens in a new tab — print or “Save as PDF” with your browser. After the client signs / chops it, take a photo and upload it as handover evidence.",
    "evidence": "Handover evidence (signed / chopped note)",
    "missingEvidence": "⚠️ Missing handover evidence: no photo of the client-signed / chopped delivery note yet — not considered complete.",
    "missingEvidenceShort": "No handover evidence",
    "evidenceOk": "✓ Handover evidence uploaded (client signature / chop).",
    "evidenceNotYet": "Upload the photo of the signed / chopped delivery note afterwards (no need on the spot).",
    "evidenceSupplierNoAccess": "Handover evidence is visible to logistics / staff / admin only.",
    "chopPhoto": "Photo of the delivery note (signed / chopped)",
    "uploadChop": "Upload delivery-note photo",
    "uploadChopHint": "Photograph the whole signed / chopped note (JPEG/PNG/WebP, ≤5 MB). ⚠️ Evidence is append-only — no delete or overwrite.",
    "uploadFailed": "Upload failed",
    "uploaded": "Uploaded ✓",
    "copied": "Copied ✓",
    "copyLink": "Copy link",
    "copyFailed": "Copy failed, please copy manually"
  },
  "recon": {
    "title": "Post-event reconciliation",
    "intro": "After delivery, a direct-sale event must be counted line by line: sold + leftover + damaged must equal what was actually picked (cartons and loose units), and only then can you confirm and post.",
    "backToOrder": "Back to order",
    "goReconcile": "Reconcile",
    "goClose": "Close order",
    "savedLines": "Counted lines",
    "savedDraft": "Draft saved (not posted) ✓",
    "confirmed": "Confirmed and posted ✓ (status is now Reconciled)",
    "confirmedAt": "Confirmed at",
    "onlyDirectSale": "Only direct-sale orders need post-event reconciliation (deliveries close on handover).",
    "needStaffToClose": "Only staff or admins can close an order.",
    "closedHint": "This order is closed (posted and locked).",
    "closeOrder": "Close order",
    "closeAsk": "Close order {{orderNo}}? (The reconciliation can no longer be changed.)",
    "closedOk": "Order closed ✓",
    "toLoc": "Destination",
    "sold": "Sold",
    "leftover": "Leftover",
    "damaged": "Damaged",
    "cartons": "cartons",
    "units": "units",
    "outCartons": "Out (actually picked)",
    "declaredCartons": "Declared",
    "unitsPerCarton": "Units per carton",
    "outUnits": "Out {{n}} units",
    "balanced": "Balanced ✓",
    "unbalanced": "Off by {{n}} units",
    "balancedOk": "Every line balances — you can confirm and post.",
    "unbalancedLines": "{{n}} line(s) still off or incomplete — cannot confirm.",
    "balanceHint": "Rule: sold + leftover + damaged equals the outbound quantity (cartons × units per carton + units). Damage needs a reason; warehouse returns must be unopened full cartons.",
    "disposition": "Leftover destination",
    "dispositionRequired": "A destination is required when there is leftover",
    "pickTarget": "Please choose…",
    "targetOrder": "Transfer to which order",
    "targetStore": "Transfer to which store",
    "toLocPreview": "Destination (preview): {{loc}}",
    "backToWarehouseHint": "Warehouse returns allow unopened full cartons only — loose units must go elsewhere.",
    "note": "Note",
    "noteRequired": "Reason (required for a write-off)",
    "summary": "Reconciliation summary",
    "summaryLines": "Balanced: {{ok}}/{{total}} lines",
    "missingDisposition": "{{n}} line(s) without a destination",
    "draftHint": "Draft saved (not posted) — ledger entries appear only after you confirm.",
    "saveDraft": "Save draft",
    "confirm": "Confirm and post",
    "confirmHint": "Confirming posts everything at once (sold SALE / leftover TRANSFER / damaged ADJUST) and locks the numbers.",
    "confirmAsk": "Confirm and post {{orderNo}}? (This cannot be changed afterwards.)",
    "needAllRows": "Cannot save yet",
    "venue": "Venue",
    "reportedAt": "Event date",
    "movements": "Ledger entries from this reconciliation",
    "movementsEmpty": "No entries yet — after you confirm they will be listed here (also visible in the stock ledger).",
    "movementSale": "Sale (SALE)",
    "movementTransfer": "Transfer (TRANSFER)",
    "movementAdjust": "Adjustment (ADJUST)",
    "viewLedger": "Open stock ledger"
  },
  "weeklyFee": {
    "title": "Weekly storage fees",
    "intro": "Storage is billed every Monday; the basis is the opening cbm of that week (full week, no pro-rata).",
    "ratesTitle": "Rates (admin settings)",
    "storageRate": "Storage (per cbm/week)",
    "handlingRate": "Intake handling (per cbm)",
    "settlementWeekday": "Settlement weekday",
    "weekdayMismatch": "⚠️ The configured settlement day is not Monday — it contradicts the Monday-opening rule; fix it on the settings page.",
    "currentWeek": "Current week ({{week}})",
    "openingCbm": "Opening cbm (basis)",
    "outboundCbm": "Outbound cbm this week",
    "closingCbm": "Closing cbm",
    "storageAmount": "Storage fee",
    "handlingAmount": "Handling fee",
    "totalAmount": "Total",
    "issues": "Integrity issues: ",
    "generate": "Generate/recalculate this week",
    "generateHint": "Monday only, no future weeks; confirmed weeks cannot be changed (adjustments need a new record).",
    "regenerated": "Draft recalculated ✓",
    "generated": "Generated ✓",
    "confirm": "Confirm",
    "confirmAsk": "Amounts cannot be changed after confirmation. Confirm week {{week}}?",
    "confirmedOk": "Confirmed ✓",
    "readOnlyHint": "(Logistics: you can check but not change any figure — add a note when confirming, or tell a staff member)",
    "skuTitle": "Opening cbm per SKU (for checking)",
    "skuHint": "Sum equals “opening cbm (billing base)” above; cbm is computed from carton dimensions (never guessed).",
    "skuEmpty": "No stock in the warehouse at the start of this week.",
    "skuCode": "Supplier",
    "skuName": "Item",
    "skuBarcode": "Barcode",
    "skuCartons": "Cartons",
    "skuCbm": "Opening cbm",
    "ack": "Confirm it is correct",
    "ackAsk": "cbm and price for {{week}} — you may add a note (e.g. matches / which item is in doubt):",
    "ackOk": "Your confirmation is recorded ✓",
    "acksTitle": "Confirmation log",
    "acksHint": "Every confirmation is recorded (who, when, note); ⚠️ this action does **not** change any amount.",
    "acksEmpty": "Nobody has confirmed yet.",
    "historyTitle": "History",
    "empty": "No weekly fees generated yet.",
    "weekLabel": "{{start}} → {{end}}",
    "draft": "Draft",
    "confirmed": "Confirmed",
    "totals": "Total (generated)"
  }
}
